import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrademeCoreUiPipeModule } from '@classifieds-sell/shared';
import {
    TgDateTimeFormatterModule,
    TgGridModule,
    TgRackModule
} from '@trademe/tangram';
import { ListingDurationService } from 'libs/property-ui/src/lib/services/listing-duration.service';
import { SummaryPageSaleDetailsSectionComponent } from './summary-page-sale-details-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgDateTimeFormatterModule,
        TgGridModule,
        TgRackModule,
        TrademeCoreUiPipeModule
    ],
    declarations: [SummaryPageSaleDetailsSectionComponent],
    exports: [SummaryPageSaleDetailsSectionComponent],
    providers: [ListingDurationService]
})
export class SummaryPageSaleDetailsSectionModule {}
